import { render, staticRenderFns } from "./Abnormal.vue?vue&type=template&id=4a93bc69"
import script from "./Abnormal.vue?vue&type=script&lang=js"
export * from "./Abnormal.vue?vue&type=script&lang=js"
import style0 from "./Abnormal.vue?vue&type=style&index=0&id=4a93bc69&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports